import styled from '@emotion/styled';
import { colors, spacing, typography } from '#themes/stena-recycling';

export const FloatingContainer = styled.div`
  background-color: ${colors.base.white};
  display: flex;
  min-width: 150px;
  max-width: 350px;
  max-height: 400px;
  flex-direction: column;
  align-items: flex-start;
  z-index: 100;
  border-radius: 4px;
  border: 1px solid ${colors.monochrome.grey20};
  box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.08);
`;

export const ItemsContainer = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  scrollbar-width: 8px;
  scrollbar-color: ${colors.monochrome.grey40} ${colors.base.white};
  color: ${colors.base.black};

  &::-webkit-scrollbar {
    width: 8px;
  }
`;

export const Item = styled.div`
  ${typography.body.large};
  color: ${colors.base.black};
  width: 100%;
  padding: ${spacing.xxsmall} ${spacing.xmsmall};
  cursor: pointer;
`;

export const SearchWrapper = styled.div`
  width: 100%;
  padding: ${spacing.xmsmall};
  box-sizing: border-box;
  border-bottom: 1px solid ${colors.monochrome.grey20};
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: ${spacing.xxsmall};
  flex-direction: row;
  padding: 0 ${spacing.xxsmall};
  justify-content: space-between;
`;

export const FilterSelector = styled.div`
  position: absolute;
  top: ${spacing.medium};
  right: 0;
  padding: ${spacing.small};
  background-color: ${colors.base.white};
`;

export const CheckBoxWrapper = styled.li<{ bottomBorder?: boolean }>`
  width: 100%;
  display: flex;
  gap: ${spacing.xxsmall};
  padding: ${spacing.xmsmall} ${spacing.xsmall};
  ${(props) => (props.bottomBorder ? `border-bottom: 1px solid ${colors.monochrome.grey20};` : '')}
`;

export const FilterActiveIndicator = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${colors.primary.blue};
  position: absolute;
  top: 4px;
  right: 0px;
`;
